import { EventCalendarPostInput } from '../../templates/inputs/EventCalendarPostInput';
import {
    DEFAULT_OPEN_LOCATION_ACTION,
    getDefaultButton,
} from '../components/ActionButton';
import { isEventsCalendarPost } from '../PostTypes';
import { EventsCalendarPostData } from '../types/EventsCalendarPostData';
import { defineTemplate } from './TemplateUtils';
import { EventsCalendarVariant } from '@lifeserver/shared';

const getBaseVariant = (): EventsCalendarVariant => ({
    imageUrl: '',
});

// The baseline (first) variant seeds the button. Unity sources the action
// button from the baseline variant and only renders it once the event is
// active, so later variants stay sparse to avoid shipping duplicate data.
const getBaselineVariant = (): EventsCalendarVariant => ({
    ...getBaseVariant(),
    button: getDefaultButton(DEFAULT_OPEN_LOCATION_ACTION),
});

const getActiveVariant = (): EventsCalendarVariant => getBaseVariant();

// Two variants is the common case: a teaser baseline shown before the event
// starts, and an "active" state the client switches to at the start date.
// The server derives each variant's `activeFrom` threshold at serve time.
const getDefaultVariants = (): EventsCalendarVariant[] => [
    getBaselineVariant(),
    getActiveVariant(),
];

export const EventCalendarSmall = defineTemplate(
    'EventsCalendar',
    'Small',
    EventCalendarPostInput,
    (): EventsCalendarPostData => ({
        $type: 'EventsCalendar',
        size: 'Small',
        entryType: 'CTA',
        variants: getDefaultVariants(),
    }),
    isEventsCalendarPost,
);

export const EventCalendarMedium = defineTemplate(
    'EventsCalendar',
    'Medium',
    EventCalendarPostInput,
    (): EventsCalendarPostData => ({
        $type: 'EventsCalendar',
        size: 'Medium',
        entryType: 'CTA',
        variants: getDefaultVariants(),
    }),
    isEventsCalendarPost,
);
